import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import KycDocument from "./KycDocument";
import AllDocuments from "./AllDocuments";
import TradeContracts from "./TradeContracts";
import SBLC from "./SBLC";
import Invoices from "./Invoices";
import Shipping from "./Shipping";

const AdmDocumentVault = () => {

    const [activeTab, setActiveTab] = useState("All Documents");
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    console.log('activeTab::',activeTab);
    const tabs = ["All Documents","KYC Document","Trade Contracts / POs","LC / SBLC Documents","Invoices","Shipping / Customs Docs"];
    const renderTabContent = () => {
        switch (activeTab) {
            case "All Documents":
                return <AllDocuments />;
            case "KYC Document":
                return <KycDocument />;
            case "Trade Contracts / POs":
                return <TradeContracts />;
            case "LC / SBLC Documents":
                return <SBLC />;
            case "Invoices":
                return <Invoices />;
            case "Shipping / Customs Docs":
                return <Shipping />;
            default:
                <AllDocuments />
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab
                                        ? "active"
                                        : "notactive"
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AdmDocumentVault;